import { useUser } from 'hooks/useUser';
import { PartnerProfile } from 'types/state';
import { createPartnerProfile } from 'utils/partnerProfileUtils';

export const useUserPartnerProfile = (): PartnerProfile => {
  const user = useUser();

  if (user?.partnerProfile) {
    return user.partnerProfile;
  }

  return createPartnerProfile();
};
